import { FC, Fragment } from 'react';
import { Grid } from '@mui/material';
// components
import RadioGroupController from 'controller/RadioGroupController';
import CommonSweetenerAndFlavorRadioGroup from 'components/common/CommonSweetenerAndFlavorRadioGroup';
// constants, interface
import { FACT_BOX_TEXT, FACT_BOX_MAPPED } from 'constants/index';
import { PowderFormProps } from 'interfaces';

/**
 * Liquid dosage form. Liquid has a single "All liquids" formulation and no
 * sub-type, so — unlike powder — there are no per-formulation sub-forms and no
 * product size / bottle type / bottle cap inputs. It is otherwise modeled on
 * the powder form: an optional fact-box selector plus sweetener/flavor.
 */
const LiquidForm: FC<PowderFormProps> = ({ isFactBox = false }) => {
  return (
    <Fragment>
      {!isFactBox && (
        <Grid item xs={12} xl={12}>
          <RadioGroupController
            isRequired
            name="factBoxType"
            title={FACT_BOX_TEXT}
            options={FACT_BOX_MAPPED}
          />
        </Grid>
      )}

      <CommonSweetenerAndFlavorRadioGroup />
    </Fragment>
  );
};

export default LiquidForm;
